import {
  customer as customerConversionUtils,
  subscriptionItem as subscriptionItemConversionUtils,
} from '../../dao/accountconversion';
import authDao from '../../dao/authDao';
import globals from '../../utils/config/globals';
import i18n from '../../utils/i18n';
import smbUtils from '../../utils/smbUtils';

const LOAD_AUTH = 'components/auth/LOAD_AUTH';
const LOAD_AUTH_SUCCESS = 'components/auth/LOAD_AUTH_SUCCESS';
const LOAD_AUTH_FAIL = 'components/auth/LOAD_AUTH_FAIL';
const LOAD_CUSTOMERS_LIST = 'components/auth/LOAD_CUSTOMERS_LIST';
const SET_ACCOUNT_SUMMARY = 'components/auth/SET_ACCOUNT_SUMMARY';
const SIGN_OUT = 'components/auth/SIGN_OUT';
const SIGN_OUT_SUCCESS = 'components/auth/SIGN_OUT_SUCCESS';
const CHANGE_LANGUAGE = 'components/auth/CHANGE_LANGUAGE';

const initialState = {
  accountSummary: {
    account: undefined,
    customer: {...customerConversionUtils.init},
    subscriptionItem: {...subscriptionItemConversionUtils.init},
    subscriptionItems: [],
    privileges: [],
  },
  customersList: [],
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case LOAD_AUTH:
    case SIGN_OUT_SUCCESS:
      return {...initialState};

    case LOAD_AUTH_SUCCESS:
    case SET_ACCOUNT_SUMMARY:
      return {
        ...state,
        accountSummary: action.accountSummary,
      };
    case LOAD_AUTH_FAIL:
    case LOAD_CUSTOMERS_LIST:
      return {
        ...state,
        customersList: action.customersList,
      };
    default:
      return state;
  }
};

export function loadAuth() {
  return dispatch => {
    dispatch({type: LOAD_AUTH});
    return authDao
      .loadAuth()
      .then(json => dispatch(loadAuthSuccess(json)))
      .catch(() => dispatch(loadAuthFail()));
  };
}

function loadAuthSuccess(accountSummary) {
  return dispatch => {
    dispatch({
      type: LOAD_AUTH_SUCCESS,
      accountSummary: {
        ...accountSummary,
        subscriptionItem: buildSubscriptionItem(
          accountSummary.subscriptionItem
        ),
      },
    });

    dispatch(changeLanguage(accountSummary.account.languageType));
    return accountSummary;
  };
}

function loadAuthFail() {
  return dispatch => {
    dispatch({type: LOAD_AUTH_FAIL});
    redirectToSignInPage();
  };
}

export function changeLanguage(languageType) {
  return dispatch => {
    const langs = globals.languages2;
    const currentLanguage = i18n.language;
    const currentLangCode = langs.find(o => o.i18n === currentLanguage);
    const newLangCode =
      langs.find(o => o.value === languageType) ||
      langs.find(o => o.value === 'enu');

    if (currentLangCode.i18n === newLangCode.i18n) return;
    if (newLangCode)
      i18n
        .changeLanguage(newLangCode.i18n)
        .then(() => dispatch({type: CHANGE_LANGUAGE}));
  };
}

export function setAccountSummary(accountSummary) {
  return {
    type: SET_ACCOUNT_SUMMARY,
    accountSummary: {
      ...accountSummary,
      subscriptionItem: buildSubscriptionItem(accountSummary.subscriptionItem),
    },
  };
}

export function signOut() {
  return dispatch => {
    dispatch({type: SIGN_OUT});

    return authDao.signOut().then(() => dispatch(signOutSuccess()));
  };
}

function signOutSuccess() {
  return dispatch => {
    dispatch({type: SIGN_OUT_SUCCESS});
    redirectToSignInPage();
  };
}

export function redirectToSignInPage() {
  smbUtils.redirectToSignInUrl(i18n.language);
}

const buildSubscriptionItem = si => {
  if (!si) {
    return si;
  }

  return {
    ...si,
    subscription: {
      ...si.subscription,
      isRenewable: si.subscription.isRenewable.toString(),
    },
  };
};
